export function safeMemberDisplayName(profile = {}, fallback = 'Member') {
  if (!profile) return fallback;
  const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim();
  if (fullName) return fullName;
  if (profile.name) return profile.name;
  if (profile.displayName) return profile.displayName;
  if (profile.username) return profile.username;
  if (profile.email) return profile.email;
  return fallback;
}
